<template>
  <v-row justify="center">
    <v-dialog v-model="IsMCUVisible" max-width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card color="#f0f0f0">
        <v-card-title>
          <span class="text-h5">Modification d'un utilisateur</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  color="#51bdcb"
                  label="E-mail de l'utilisateur"
                  required
                  class="field"
                  v-model="userU.email"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  :items="roles"
                  v-model="role"
                  name="role"
                  :rules="[(v) => !!v || 'Un rôle doit être sélectionné']"
                  label="Selection du rôle"
                  color="#51bdcb"
                  item-color="dark"
                >
                </v-select>
                Rôle actuel : {{ user.role || 'vide' }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-checkbox
                  v-model="modifPassword"
                  label="Modifier le mot de passe"
                ></v-checkbox>
              </v-col>
              <v-col v-if="modifPassword" cols="8">
                <v-text-field
                  :type="show ? 'text' : 'password'"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="passwordRules"
                  rows="1"
                  color="#51bdcb"
                  label="Nouveau mot de passe"
                  required
                  class="field"
                  v-model="password"
                  @click:append="show = !show"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="blankError">
              <v-col>
                <v-alert
                  border="right"
                  colored-border
                  type="error"
                  elevation="2"
                >
                  Veuillez remplir tous les champs s'il vous plaît
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#51bdcb" text @click="closeMCU"> Annuler </v-btn>
          <v-btn color="#51bdcb" text @click="updateUser"> Modifier </v-btn>
        </v-card-actions>
      </v-card>
      <template v-if="isErrorMessageDisplayed"> <PopUpError /></template>
    </v-dialog>
  </v-row>
</template>

<script>
import { UPDATE_USER } from '../graphql/GraphQLMutations';
import { GET_ALL_USERS } from '../graphql/GraphQLQueries';
import PopUpError from './PopUpError.vue';

const _ = require('lodash');

export default {
  name: 'ModalUpdateUser',

  components: {
    PopUpError,
  },

  apollo: {
    getAllUsers: {
      query: GET_ALL_USERS,
      error(error) {
        if (error.graphQLErrors.length > 0) {
          if (error.graphQLErrors[0].message === 'Unauthenticated!') {
            if (localStorage) {
              localStorage.removeItem('apollo-token');
            }
            this.$router.push('/');
          }
        }
        console.error(error); // eslint-disable-line no-console
      },
    },
  },

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    userU: {},
    show: false,
    IsMCUVisible: false,
    blankError: false,
    modifPassword: false,
    email: '',
    password: '',
    role: '',
    passwordRules: [
      (v) => !!v || 'Le mot de passe doit être rempli',
      (v) =>
        v.length >= 4 || 'Le mot de passe doit contenir au moins 4 caractères',
    ],
    roles: ['Admin', 'Utilisateur'],
    reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    isErrorMessageDisplayed: false,
  }),

  mounted() {
    if (this.user) {
      this.userU = this.user;
    }
  },

  methods: {
    closeMCU() {
      this.blankError = false;
      this.IsMCUVisible = false;
    },
    getEmailToken() {
      const token = localStorage.getItem('apollo-token');
      if (token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64)).email;
      }
      return false;
    },
    updateUser() {
      this.isErrorMessageDisplayed = false;
      let result;
      // Si on selectionne la modification de mdp mais aucun mdp est saisi
      if ((this.modifPassword && !this.password) || this.role === '') {
        this.blankError = true;
      } else {
        if (this.modifPassword) {
          result = {
            id: this.user.id,
            email: this.user.email,
            password: this.password,
            role: this.role,
          };
        } else {
          result = {
            id: this.user.id,
            email: this.user.email,
            role: this.role,
          };
        }

        this.$apollo
          .mutate({
            mutation: UPDATE_USER,
            variables: result,
            update: (cache, { data: { updateUser } }) => {
              const data = cache.readQuery({ query: GET_ALL_USERS });
              const index = _.findIndex(data.getAllUsers, {
                id: updateUser.id,
              });
              data.getAllUsers.splice(index, 1, updateUser);
              cache.writeQuery({ query: GET_ALL_USERS, data });
            },
          })
          .then(() => {
            // TODO
            if (this.modifPassword) {
              localStorage.removeItem('apollo-token');
              this.$router.push('/');
            }
            this.IsMCUVisible = false;
          })
          .catch(() => {
            this.isErrorMessageDisplayed = true;
          });
      }
    },
  },
};
</script>
